<template>
  <div class="airDetails" v-if="detailData">
    <div class="Details_data">
      <h5>创建时间: {{detailData.orderTime}}</h5>
      <div class="Details_text df">
        <span>订单号 : {{orderNo || detailData.orderId}}</span>
        <span>订单类型 : {{detailData.flightTypeTxt || detailData.flightTypeText}}</span>
        <span>订单状态 : {{detailData.orderStatusTxt || detailData.orderStatusText}}</span>
        <span>出票时间 : {{detailData.ticketTime || '暂无'}}</span>
        <span>票面总价 : {{ Number(detailData.payAmount).toFixed(2)}}</span>
      </div>
    </div>
    <div class="passenger" v-show="type !== 'Dishonour' && type !== 'Changing'">
      <h2>
        <p>航班信息</p>
      </h2>
      <el-row type="flex" class="passenger_top">
        <el-col :span="4">乘客姓名</el-col>
        <el-col :span="4">乘客类型</el-col>
        <el-col :span="6">证件号码</el-col>
        <el-col :span="4">出生年月</el-col>
        <el-col :span="6">票号</el-col>
      </el-row>
      <div class="passenger_body" v-for="(item,index) in passengers" :key="index">
        <div class="passengerD clear">
          <el-col :span="4">{{item.psgName}}</el-col>
          <el-col :span="4">
            <span v-if="item.psgType === '1'">成人</span>
            <span v-if="item.psgType === '2'">儿童</span>
            <span v-if="item.psgType === '3'">婴儿</span>
          </el-col>
          <el-col :span="6">{{item.cardNo}}</el-col>
          <el-col :span="4">{{item.birthday}}</el-col>
          <el-col :span="6">
            <p>{{item.initialTicketNumber}}</p>
          </el-col>
        </div>
        <div class="airList" v-for="(childItem,childIndex) in item.routeList" :key="childIndex">
          <div class="airList">
            <div class="airList_Top">
              <el-col :span="3">航班类型</el-col>
              <el-col :span="3">航班号</el-col>
              <el-col :span="3">航空公司</el-col>
              <el-col :span="3">航班日期</el-col>
              <el-col :span="3">出发地</el-col>
              <el-col :span="3">到达地</el-col>
              <el-col :span="3">舱位</el-col>
              <el-col :span="3">状态</el-col>
            </div>
            <div>
              <el-col :span="3">{{childItem.segmentType==1?'去程':'回程'}}</el-col>
              <el-col :span="3">{{childItem.flightNo}}</el-col>
              <el-col :span="3">{{childItem.airCompanyName}}</el-col>
              <el-col :span="3">{{childItem.beginDate}}</el-col>
              <el-col :span="3">{{childItem.sCityName}}({{childItem.sCityCode}})</el-col>
              <el-col :span="3">{{childItem.eCityName}}({{childItem.eCityCode}})</el-col>
              <el-col :span="3">{{childItem.cabinCode}}</el-col>
              <el-col :span="3">
                <span>{{detailData.orderStatusTxt}}</span>
              </el-col>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="type == 'Changing'">
    <div class="passenger">
      <h2>
        <p>航班信息</p>
      </h2>
      <div  class="fare-list">
        <div class="air-list">
          <el-table
            :data="detailData.routeList || detailData.segmentList"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="航程" align="center">
              <template slot-scope="scope">
                  {{scope.row.segmentType==1?'去程':'回程'}}
              </template>
            </el-table-column>
            <el-table-column prop="flightNo" label="航班号" align="center" v-if="supplierType==1"></el-table-column>
            <el-table-column prop="cabinCode" label="舱位" align="center" v-if="supplierType==1"></el-table-column>
            <el-table-column  label="起抵地" align="center" width="250">
               <template slot-scope="scope">
                 {{scope.row.sAirportName || scope.row.sAirportNames}}({{scope.row.sAirportCode||scope.row.sAirportCodes}})/
                 {{scope.row.eAirportName || scope.row.eAirportNames}}({{scope.row.eAirportCode || scope.row.eAirportCodes}})
               </template>
            </el-table-column>
            <el-table-column prop="cabinRanks" label="舱位等级" align="center" v-if="supplierType==0">
              <template slot-scope="scope">
                {{scope.row.cabinRanks==1?'头等舱':
                scope.row.cabinRanks==2?'公务舱':
                '经济舱'}}
                </template>
            </el-table-column>
            <el-table-column  label="起飞时间" align="center">
               <template slot-scope="scope">
                 {{scope.row.beginDate}}/{{scope.row.beginTime}}
               </template>
            </el-table-column>

            <el-table-column  label="到达时间" align="center">
               <template slot-scope="scope">
                 {{scope.row.arriveDate}}/{{scope.row.arriveTime}}
               </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
     <div class="passenger">
      <h2>
        <p>改签航班信息</p>
      </h2>
      <div  class="fare-list">
        <div class="air-list">
          <el-table
            :data="ticketFlight"
            style="width: 100%"
          >
            <el-table-column label="航程" width="60" align="center">
              <template slot-scope="scope">
                 {{scope.row.segmentType==1?'去程':'回程'}}
              </template>
            </el-table-column>
            <el-table-column prop="flightNo" label="航班号" width="100" align="center" v-if="supplierType==1">
              <template slot-scope="scope">
                <el-input v-model="scope.row.flightNo"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="cabinCode" label="舱位" align="center" width="80" v-if="supplierType==1">
              <template slot-scope="scope">
                <el-input v-model="scope.row.cabinCode"></el-input>
              </template>
            </el-table-column>
            <el-table-column  label="出发地" align="center" width="180">
               <template slot-scope="scope">
                 <el-autocomplete
                      v-model="scope.row.sAirportName"
                      v-if="supplierType==1"
                      :fetch-suggestions="querySearchAsync"
                      @select="(val)=>handleSelect(val,scope.row,'start')"
                    ></el-autocomplete>
                 <span v-else>{{scope.row.sAirportNames}}({{scope.row.sAirportCodes}})</span>
               </template>
            </el-table-column>
            <el-table-column  label="到达地" align="center" width="180">
               <template slot-scope="scope">
                 <el-autocomplete
                      v-model="scope.row.eAirportName"
                      v-if="supplierType==1"
                      :fetch-suggestions="querySearchAsync"
                      @select="(val)=>handleSelect(val,scope.row,'end')"
                    ></el-autocomplete>
                  <span v-else>{{scope.row.eAirportNames}}({{scope.row.eAirportCodes}})</span>
               </template>
            </el-table-column>
            <el-table-column  label="起飞时间" align="center">
               <template slot-scope="scope">
                 <div class="table-time">
                   <el-date-picker
                      v-model="scope.row.beginDate"
                      type="date"
                      :picker-options='setTime()'
                      value-format="yyyy-MM-dd"
                      placeholder="出发日期">
                  </el-date-picker>
                  <br>
                  <el-time-picker
                    v-model="scope.row.beginTime"
                    value-format="HH:mm"
                    placeholder="出发时间" v-if="supplierType==1">
                  </el-time-picker>
                 </div>
               </template>
            </el-table-column>
            <el-table-column  label="到达时间" align="center" v-if="supplierType==1">
               <template slot-scope="scope">
                  <div class="table-time">
                   <el-date-picker
                      v-model="scope.row.arriveDate"
                      type="date"
                      :picker-options='setTime(scope.row.beginDate)'
                      value-format="yyyy-MM-dd"
                      placeholder="到达日期">
                  </el-date-picker>
                  <br>
                  <el-time-picker
                    v-model="scope.row.arriveTime"
                     value-format="HH:mm"
                    placeholder="到达时间">
                  </el-time-picker>
                 </div>
               </template>
            </el-table-column>
             <el-table-column  label="舱位等级" align="center">
               <template slot-scope="scope">
                 <el-select v-model="scope.row.cabinRank" v-if="supplierType==1">
                    <el-option label="头等舱" value="1"></el-option>
                    <el-option label="公务舱" value="2"></el-option>
                    <el-option label="经济舱" value="3"></el-option>
                  </el-select>
                 <el-select v-model="scope.row.cabinRanks" v-else>
                    <el-option label="头等舱" value="1"></el-option>
                    <el-option label="公务舱" value="2"></el-option>
                    <el-option label="经济舱" value="3"></el-option>
                  </el-select>
               </template>
            </el-table-column>
             <!-- <el-table-column  label="备注" align="center">
               <template slot-scope="scope">
                 <el-input v-model="scope.row.remark"></el-input>
               </template>
            </el-table-column> -->
          </el-table>
        </div>
        <div class="flex-center-end" style="padding:0 10px 10px 0;" v-if="supplierType == 0">
          <p style="padding:0 10px;">
            <span style="padding-right:10px">成人：{{fligthPeople.adults}}</span>
            <span>儿童：{{fligthPeople.children}}</span>
          </p>
          <el-button size="small" type="primary" @click="getInternationalList">搜索可申请航班</el-button>
        </div>
      </div>
    </div>
    <div class="passenger">
      <h2>
        <p>改签乘客</p>
      </h2>
      <div  class="fare-list">
        <div class="air-list">
          <el-table
            :data="passengeList"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleTicket"
          >
            <el-table-column type="selection" width="55" :selectable='checkboxInit' v-if="handleTicketBtn"></el-table-column>
            <el-table-column label="姓名"  align="center">
              <template slot-scope="scope">
                  {{scope.row.psgName?scope.row.psgName:scope.row.firstName+'/'+scope.row.lastName}}
              </template>
            </el-table-column>
            <el-table-column prop="flightNo" label="类型" width="120" align="center">
              <template slot-scope="scope">
                  {{scope.row.psgType==1?'成人':
                  scope.row.psgType==2?'儿童':'婴儿'}}
              </template>
            </el-table-column>
            <el-table-column prop="initialTicketNumber" label="原票号" align="center"></el-table-column>
            <!-- <el-table-column  label="电子行程单" align="center" prop="cabinCode">
            </el-table-column> -->
          </el-table>
        </div>
      </div>
    </div>
    <div class="passenger" v-show="supplierType==1">
      <h2>
        <p>联系信息</p>
      </h2>
      <div class="relation-box flex-center-end">
          <div>
            <span>联系人:</span>
            <el-input v-model="detailData.contactName"></el-input>
          </div>
           <div>
            <span>联系电话:</span>
            <el-input v-model="detailData.contactTel"></el-input>
          </div>
           <div>
            <span>邮箱:</span>
            <el-input v-model="detailData.contactEmail"></el-input>
          </div>
      </div>
      <div class="relation-box" style="padding-top:0">
          <p class="title">备注:</p>
          <el-input
            type="textarea"
            :rows="4"
            v-model="detailData.remark">
          </el-input>
      </div>
    </div>
     <div class="passenger" v-if="supplierType == 0">
       <h2><p>可改签航班信息</p></h2>
       <div v-loading="loading">
          <div v-if="changeFligthList.length==0" class="font-13 flex-center" style="padding:30px;color:#999" >暂无数据</div>
          <div class="flights-content" v-for="(item,index) in changeFligthList" :key="index" v-else>
          <div v-for="(flighDetails,flighDetailsIndex) in item.segmentList" :key="flighDetailsIndex">
            <span class="flight-route-style" :class="{'flight-route-style2':flighDetails.segmentType!=1}">{{flighDetails.segmentType==1?'去程':'回程'}}</span>
          <div class="flights-contentT df">
            <div class="flights-nub">
              <img :src="flighDetails.airCompanyLogoImg || image_url_airline_blank_map" alt="" class="float-left">
              <div class="float-left" style="padding-left:20px;text-align:left">
                <p>
                {{flighDetails.airCompanyName}}
              </p>
              <span style="padding-top:5px;word-break: break-word;width:140px">
                {{flighDetails.flightNo.replace(/,/g, "/")}}
              </span>
              </div>
            </div>
            <div class="flights-type">
              {{flighDetails.planeType.replace(/,/g, "/")}}
            </div>
             <div class="flights-data df">
              <div class="flights-star">
                <h5>{{flighDetails.beginTime}}</h5>
                <span>
                 {{flighDetails.sAirportName}}{{flighDetails.sTerminal}}
                </span>
              </div>
              <div class="arrows clear" :style="{'margin-top':item.segmentList[flighDetailsIndex].transitCityNames.split(',').length * 20+'px'}">
                <div class="transfer-box" v-if="item.segmentList[flighDetailsIndex].transitCityNames">
                  <p v-for="(transitCityNamesItem,transitCityNamesIndex) in  item.segmentList[flighDetailsIndex].transitCityNames.split(',')" :key="transitCityNamesIndex">
                    转 {{transitCityNamesItem}}</p>
                </div>
               <div class="arrows-stop"
                @mouseenter="$set(arrowsInfoShow[index],flighDetailsIndex,true)" @mouseleave="$set(arrowsInfoShow[index],flighDetailsIndex,false)"></div>
                <div class="arrows-stop-info" :class="{'fare-info-animation':arrowsInfoShow[index][flighDetailsIndex]}"
                >
                   <p class="arrows-stop-info-title" >航班详情</p>
                   <div class="arrows-stop-info-box">
                     <div class="info-box-title flex-center-end">
                       <span>航班日期:{{flighDetails.routeList[0].beginDate}}
                         星期{{new Date(flighDetails.routeList[0].beginDate).getDay()==1?'一':
                         new Date(flighDetails.routeList[0].beginDate).getDay()==2?'二':
                         new Date(flighDetails.routeList[0].beginDate).getDay()==3?'三':
                         new Date(flighDetails.routeList[0].beginDate).getDay()==4?'四':
                         new Date(flighDetails.routeList[0].beginDate).getDay()==5?'五':
                         new Date(flighDetails.routeList[0].beginDate).getDay()==6?'六':'日'}}</span>
                      <span>全程时间:{{flighDetails.duration.replace(/:/,'小时')}}分钟</span>
                     </div>
                     <div  v-for="(routeListItem,routeListIndex) in flighDetails.routeList" :key="routeListIndex">
                     <div class="info-box-list flex-center-end">
                       <img :src="routeListItem.airCompanyLogoImg || image_url_airline_blank_map" alt="">
                       <div>
                         <p>{{routeListItem.airCompanyName}}</p>
                         <p>{{routeListItem.flightNo}}</p>
                       </div>
                       <div class="info-box-text">
                          <div class="flex-center-end">
                           <span>起飞: {{routeListItem.beginDate}}</span>
                           <span>{{routeListItem.beginTime}}</span>
                           <span>{{routeListItem.sCityName}}</span>
                           <span>{{routeListItem.sAirportName}}</span>
                          </div>
                          <div class="flex-center-end">
                           <span>降落: {{routeListItem.arriveDate}}</span>
                           <span>{{routeListItem.arriveTime}}</span>
                           <span>{{routeListItem.eCityName}}</span>
                           <span>{{routeListItem.eAirportName}}</span>
                          </div>
                       </div>
                       <div>
                         <span>{{routeListItem.duration.replace(/:/,'h')}}m</span>
                       </div>
                     </div>
                     <div class="info-box-list-hint" v-if="flighDetails.routeList.length>1" v-show="(routeListIndex + 1)!==flighDetails.routeList.length">
                       <div class="info-box-list-hint-box flex-center-end">
                         <span>中转: {{routeListItem.eCityName}}</span>
                         <span>停留时长: {{flighDetails.durationOfTransitCity.replace(/h/,'小时').replace(/m/,'分钟')}}</span>
                       </div>
                     </div>
                     </div>
                   </div>
                </div>
              </div>

              <div class="flights-end">
                <h5>{{flighDetails.arriveTime}}</h5>
                <span>
                  {{flighDetails.eAirportName}} {{item.segmentList[flighDetailsIndex].eTerminal}}
                </span>
              </div>
            </div>
            <div class="flights-catering ">
                 {{flighDetails.duration.replace(/:/, "h")}}m
            </div>
          </div>
          </div>
          <div>
            <div class="flights-contentB" style="display:flex;justify-content:flex-end;align-items: center">
                 <div style="margin-right:30px">
                   <el-button size="small" @click="applyAir(item)" type="success">申请改签</el-button>
                 </div>
            </div>
          </div>
        </div>
       <div class="ticket-paging flex-center" v-if="changeFligthList.length!=0">
           <el-pagination
          background
          @current-change="handleCurrentChange"
          :page-size="searchFlight.pageSize"
          :current-page="searchFlight.currentPage"
          layout="total, prev, pager, next"
          :total="searchFlight.totalCount">
        </el-pagination>
       </div>
       </div>
     </div>

    <div class="passenger" v-if="supplierType==1">
      <h2>
        <p>改签费用</p>
      </h2>
      <div class="relation-box">
        <p>改签相关费用提交申请后,由专属客服与您联系确认。</p>
      </div>
    </div>

    </div>
    <div class="passenger" v-show="type==='airDetails'">
      <h2>
        <p>价格信息</p>
      </h2>
      <div style="padding:10px 0 0 0;" v-for="(priceItem,priceIndex) in detailData.priceList" :key="priceIndex">
        <el-row
          type="flex"
          style="padding:10px;background:#f1f3f5;text-align:center"
          class="font-13"
        >
          <el-col :span="4">乘客类型</el-col>
          <el-col :span="6">票面/税金</el-col>
          <el-col :span="6">开票费</el-col>
          <el-col :span="2">返佣</el-col>
          <el-col :span="2">行程单</el-col>
          <el-col :span="4">单张结算价</el-col>
        </el-row>
        <el-row type="flex" class="font-13 price-list">
          <el-col :span="4">{{priceItem.psgTypeTxt}}</el-col>
          <el-col :span="6">{{Number(priceItem.fare).toFixed(2)}}/{{Number(priceItem.tax).toFixed(2)}}</el-col>
          <el-col :span="6">{{Number(priceItem.tktFee).toFixed(2)}}</el-col>
          <el-col :span="2">{{Number(priceItem.hireFee).toFixed(2)}}</el-col>
          <el-col :span="2">{{Number(priceItem.itinerary).toFixed(2)}}</el-col>
          <el-col :span="4">
            <span class="font-10">￥</span><span>{{Number(priceItem.price).toFixed(2)}}</span>
          </el-col>
        </el-row>
      </div>
      <p class="text-warning">退改签按航司客规文件执行，特惠产品请与客服确认</p>
    </div>
    <div class="passenger" v-show="detailData.baggageInfo">
      <h2>
        <p>行李信息</p>
      </h2>
      <div style="padding:10px;">
        <el-input type="textarea" :autosize="{ minRows: 2}" v-model="detailData.baggageInfo"/>
      </div>
    </div>
    <div class="passenger" v-show="type==='Dishonour'|| type==='changPay'">
      <h2>
        <p>乘客/航程信息</p>
      </h2>
      <div  class="fare-list" v-for="(item,index) in passengers" :key="index">
        <div class="people-info">
          <el-checkbox v-model="checkList[index]" @change="checkPeople(item,checkList[index])" v-show="type==='changPay'"></el-checkbox>
          <span>乘客姓名：{{item.psgName}}</span>
          <span>乘客类型：{{item.psgTypeTxt}}</span>
          <span>证件信息：{{item.cardNo}}</span>
          <span>票号：{{item.initialTicketNumber}}</span>
        </div>
        <div class="air-list">
          <h4>航程信息</h4>
          <el-table
            :data="item.routeList"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55" v-if="type=='Dishonour'"></el-table-column>
            <el-table-column label="航程" width="120" align="center">
              <template slot-scope="scope">
                  {{scope.row.segmentType==1?'去程':'回程'}}
              </template>
            </el-table-column>
            <el-table-column prop="flightNo" label="航班号" width="120" align="center"></el-table-column>
            <el-table-column prop="cabinCode" label="舱位" align="center"></el-table-column>
            <el-table-column  label="起抵地" align="center">
               <template slot-scope="scope">
                 {{scope.row.sCityName}}({{scope.row.sCityCode}})/
                 {{scope.row.eCityName}}({{scope.row.eCityCode}})
               </template>
            </el-table-column>
            <el-table-column  label="起飞时间" align="center">
               <template slot-scope="scope">
                 {{scope.row.beginDate}}/{{scope.row.beginTime}}
               </template>
            </el-table-column>
            <el-table-column  label="到达时间" align="center">
               <template slot-scope="scope">
                 {{scope.row.arriveDate}}/{{scope.row.arriveTime}}
               </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <div class="passenger" v-show="type=='Dishonour'||type==='changPay'">
      <h2>
        <p>备注</p>
      </h2>
      <div style="padding:10px;">
        <el-input type="textarea" :autosize="{ minRows: 4}" v-model="remark"/>
      </div>
    </div>
    <!-- <div class="passenger">
      <h2>
        <p>废票结果</p>
      </h2>
    </div>-->
    <div class="flex-center" v-if="type!=='airDetails'">
      <el-button type="primary" size="small" @click="submit" v-show="type!='Changing'">提交</el-button>
      <el-button  size="small" @click="amend('airDetails')">返回</el-button>
    </div>
     <div class="flex-center" v-else >
      <el-button type="primary" size="small" @click="amend('Dishonour')" v-show="detailData.orderStatus==22">申请退票</el-button>
      <el-button  size="small" type="success" @click="amend('Changing')" v-show="detailData.orderStatus==22">申请改签</el-button>
      <el-button  size="small" type="warning" @click="amend('changPay')"  v-show="detailData.orderStatus==22">申请废票</el-button>
      <el-button  size="small" @click="$router.push({name:'air-ticket-admin-international-list'})">返回</el-button>
    </div>
    <el-dialog
      title="申请改签"
      :visible.sync="applyStatus.show"
      :close-on-click-modal="false"
      width="500px"
      >
      <div>
        <span class="font-13" style="padding:0 0 10px 0;">备注:</span>
        <el-input
          type="textarea"
          :rows="4"
          placeholder="请输入内容"
          v-model="applyStatus.text">
        </el-input>
        <div class="passenger">
          <h2>
            <p>改签费用</p>
          </h2>
          <div class="relation-box">
            <p>改签相关费用提交申请后,由专属客服与您联系确认。</p>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="applyStatus={show:false}" size="small">取 消</el-button>
        <el-button type="primary" @click="submit(applyStatus.value)" size="small">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// 订单查询
import detail from "@/lib/data-service/flight/fligthInternationalAdmin/flight_international_buyer_manage_order_detail.js";
import scrollTop from '@/lib/common-service/scrollTop'
import invalid from "@/lib/data-service/flight/fligthInternationalAdmin/flight_international_buyer_white_order_invalid.js";
import refund from "@/lib/data-service/flight/fligthInternationalAdmin/flight_international_buyer_white_order_refund.js";
import findChangeOrder from "@/lib/data-service/flight/fligthInternationalAdmin/flight_inter_buyer_manage_order_findChangeOrder.js";
import {internationalCity,findPkfareChangeReshop,pkfareChangeRequest} from '@/lib/data-service/flight/fligthInternational'
import findPkChangeOrder from "@/lib/data-service/flight/fligthInternationalAdmin/flight_inter_buyer_manage_order_findPkfareChangeOrder";

import  orderChange from '@/lib/data-service/flight/fligthInternationalAdmin/flight_international_buyer_white_order_change'

export default {
  data() {
    return {
      detailData: null,
      applyStatus:{show:false},
      orderNo: "",
      orderStatus: "",
      flightType: "1",
      passengers: [],
      checkList: [],
      trunkShow:null,
      clauseShow:null,
      arrowsInfoShow:[],
      type:'',
      checkPeopleList:[],
      checkFlight:[],
      remark:'',
      formData:{},
      internationalAir:[],
      ticketFlight:[],
      ticketPassenger:[],
      passengeList:[],
      handleTicketBtn:false,
      supplierType:1,
      fligthPeople:{
        adults:0,
        children:0
      },
      loading:false,
      searchFlight:{
        currentPage:1,
        pageSize:5,
        totalCount:0
      },
      changeFligthList:[],
      image_url_airline_blank_map:`https://lyn.oss-cn-shenzhen.aliyuncs.com/temp/airline-blank-map.jpg`,
    };
  },
  methods: {
    handleSelectionChange(val){
        this.checkFlight = val
        let type = this.$route.query.type
        let poepleList = this.detailData.passengeList
        this.passengeList = []
        val.length==0?this.handleTicketBtn = false:this.handleTicketBtn = true
        this.ticketFlight = JSON.parse(JSON.stringify(this.checkFlight))
        if(type=='Changing'){
          poepleList.map(item=>{
           item.showStatus = 0
          })
          val.map(list=>{
              poepleList.map(item=>{
                if(item.segment.indexOf(list.serialNumber)==-1){
                  item.showStatus++
                }else{
                  item.show = true
                }
              })
          })
          poepleList.map(item=>{
            item.showStatus>0?item.show = false:''
          })
        }
        setTimeout(()=>{
          this.passengeList = this.detailData.passengeList
        },100)
    },
    // 日期选择
    setTime(startDate) {
      return {
        disabledDate: time => {
            if(startDate){
              return time.getTime() < this.$moment(startDate)._d.valueOf()
            }else{
               return time.getTime() < Date.now() - 1000 * 3600 * 24
            }
        }
      };
    },
    applyAir(value){
       this.applyStatus.show = true
       this.applyStatus.value = value
    },
    checkboxInit(row,index){
       if(!row.show){
         return false
       }else{
          return true
       }
    },
    handleTicket(val){
       this.ticketPassenger = val
       let adults = 0,children = 0
       this.ticketPassenger.map(item=>{
          //  console.log(item)
           item.psgType==1?adults++:item.psgType==2?children++:''
       })
       this.fligthPeople = {adults,children}
    },
    checkPeople(val,statu){
      statu?
      this.checkPeopleList.push(val):queryList(this.checkPeopleList)
      function queryList(list){
          list.map((item,index)=>{
             if(item.psgId==val.psgId){
                 list.splice(index,1)
             }
          })
      }
    },
    querySearchAsync(queryString,cb){
      var restaurants = this.internationalAir
      var results = queryString
        ? restaurants.filter(filtrate(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results)
      function filtrate(list){
        return (restaurant) => {
        if(restaurant.spell.toUpperCase()===list.toUpperCase()){
            restaurant.value = restaurant.name
            return restaurant
        }else if(restaurant.name.indexOf(list) != -1){
          restaurant.value = restaurant.name
            return restaurant
        }else if(restaurant.code.indexOf(list.toUpperCase()) !== -1){
          restaurant.value = restaurant.name
            return restaurant
        }
      }
      }
    },
    handleCurrentChange(val){
       this.searchFlight.currentPage = val
       this.getInternationalList()
    },
    getInternationalList(){
      if(this.ticketFlight.length==0)return this.$message({type:"warning",message:"请选择改签航班！"})
      for(let i in this.ticketFlight){
        if(!this.ticketFlight[i].beginDate){
          return this.$message({type:"warning",message:"请选择起飞时间！"})
        }
      }
      if(this.fligthPeople.adults==0)return this.$message({type:"warning",message:"请选择改签乘客！"})
      let fligthArr = []
      fligthArr = this.ticketFlight.map(item=>{
         let fligth = {
            "cabinClass": item.cabinRanks,
            "departureDate": item.beginDate,
            "destination": item.eAirportCodes,
            "origin": item.sAirportCodes
         }
        return fligth
      })
      let params = {
          "adults": this.fligthPeople.adults,
          "children":  this.fligthPeople.children,
          "currentPage": this.searchFlight.currentPage,
          "orderNo": this.orderNo,
          "pageSize": this.searchFlight.pageSize,
          "segmentList":fligthArr
        }
      this.loading = true
      findPkfareChangeReshop(params).then(res=>{
         this.arrowsInfoShow = res.pageResult.pageData.map((item,index)=>{
            return item.segmentList.map(item=>{
              return false
            })
        })
         res.code == this.SUCCESS_CODE?
         this.changeFligthList = res.pageResult.pageData:''
         this.searchFlight.totalCount = res.pageResult.totalCount
         this.loading = false
      })
    },
    handleSelect(val,list,type){
      type=='start'?
      list.sAirportCode = val.code:list.eAirportCode = val.code
    },
    // 获取城市接口
    loadAllInternationalCity() {
       internationalCity().then(res => {
        let airList = []
        airList = res.citys.filter(item=>{
            return item.airports==true
        })
        this.internationalAir = airList
      })
    },
    getDetail(text){
      this.detailData = []
      let _this = this
      if(text=='Changing'){
        if(this.supplierType==1){
          findChangeOrder({orderNo :this.orderNo}).then(res=>{
            this.detailData = res.changeDetail
            this.detailData.routeList.map(item=>{
              item.cabinRank = '3'
            })
            passengeShow(res.changeDetail)
            this.passengeList = this.detailData.passengeList
         })
        }else{
          findPkChangeOrder({orderNo:this.orderNo }).then(res=>{
           this.detailData = res.changeDetail
            passengeShow(res.changeDetail)
            this.passengeList = this.detailData.passengeList
         })
        }
      }
      else{
        detail({ orderId: this.orderNo }).then(res => {
        this.detailData = res.data;
        this.passengers = res.data.passengerList;
        this.$forceUpdate();
       })
      }
      function passengeShow(list){
        list.passengeList.map((item,index)=>{
              let _arr = []
              list.relationList.map(relation=>{
                relation.psgIdList.indexOf(item.psgId)!=-1?
                 _arr.push(relation.serialNumber):''
            })
            item.segment = _arr
            item.show = false
            item.showStatus = 0
        })
      }
      scrollTop(300)
    },
    submit(value){
      let type = this.$route.query.type
      switch (type){
        case 'Dishonour':
          this.setDishonour()
          break;
        case 'Changing':
          this.setChanging(value)
          break;
        case 'changPay':
          this.setChangPay()
          break;
        default:
          break;
      }
    },
    //退票
    setDishonour(){
      if(this.checkFlight.length==0)return this.$message({type:"warning",message:"请选择乘客"})
      if(!this.remark)return this.$message({type:"warning",message:"请填写备注"})
      let linId = this.checkFlight.map(item=>{
          return item.airlineId
      })
      let psgId = this.checkFlight.map(item=>{
          return item.psgId
      })
        let data = {
              "lineId": linId.join(','),
              "orderNo": this.detailData.orderNo,
              "psgIds": psgId.join(','),
              "refundOperation": 1,
              "refundType": 1,
              "remark": this.remark
            }
      refund(data).then(res=>{
        console.log(res)
        (this.$message({type:"success",message:"退票成功！"}),this.$router.push({name:'air-ticket-admin-cancel-order'}))
      })
    },
    //废票
    setChangPay(){
       if(this.checkPeopleList.length==0)return this.$message({type:"warning",message:"请选择乘客"})
       if(!this.remark)return this.$message({type:"warning",message:"请填写备注"})
       let psgId = this.checkPeopleList.map(item=>{
              return item.psgId
       })
       let data = {
         orderNo:this.detailData.orderNo,
         passengerId:psgId.join(','),
         remark:this.remark
       }
       invalid(data).then(res=>{
         console.log(res)
         (this.$message({type:"success",message:"废票成功！"}),this.$router.push({name:'air-ticket-admin-cancellation-order'}))
       })
    },
    //改签
    setChanging(value){
       if(this.ticketPassenger.length==0)return this.$message({type:"warning",message:"请选择改签乘客"})
       if(this.ticketFlight.length==0)return this.$message({type:"warning",message:"请选择改签航班"})

      //  this.ticketFlight.every(item=>{
              // if(!item[i]){
              //   this.$message({type:"warning",message:"请完善改签航班信息！"})
              //    return true
              // }
      //  })
      if(this.supplierType==1){
       let passengerList = this.ticketPassenger.map(item=>{
           let obj = {
              "birthday": item.birthday,
              "firstName": item.psgName.split('/')[1],
              "gender": item.gender,
              "lastName": item.psgName.split('/')[0],
              "psgId": item.psgId,
              "psgType":item.psgType
           }
           return obj
       })
       let ticketFlight = this.ticketFlight.map(item=>{
           console.log(item)
           let obj = {
              "airlineCode": item.flightNo.slice(0,2),
              "arrAirportCode": item.eAirportCode,
              "arrDate": item.arriveDate,
              "arrTime": item.arriveTime,
              "cabinCode": item.cabinCode,
              "cabinRank": item.cabinRank,
              "depAirportCode": item.sAirportCode,
              "depDate": item.beginDate,
              "depTime": item.beginTime,
              "flightNo": item.flightNo,
              "routeId": item.airlineIds,
              "supplierRouteId": item.supplierAirlineNo
            }
            return obj
       })
       let data = {
          "changes": ticketFlight,
          "orderNo": this.detailData.orderId,
          "passengerList": passengerList
      }
        orderChange(data).then(res=>{
        res.isSuccess?
        (this.$message({type:"success",message:"改签成功！"}),this.$router.push({name:'air-ticket-admin-change-order'})):''
       })
      }else{
        let passengerList = this.ticketPassenger.map(item=>{
           let obj = {
              "birthday": item.birthday,
              "firstName": item.firstName,
              "gender": item.gender,
              "lastName": item.lastName,
              "psgId": item.psgId,
              "psgType":item.psgType
           }
           return obj
       })
       let ticketFlight = value.segmentList.map((flightItem,flightIndex)=>{
            let routeList = flightItem.routeList.map((item,index)=>{
                   let obj = {
                      "airlineCode": item.airCompanyCode,
                      "arrAirportCode": item.eAirportCode,
                      "arrDate": item.arriveDate,
                      "arrTime": item.arriveTime,
                      "cabinCode": item.cabinCode,
                      "cabinRank": this.ticketFlight[flightIndex].cabinRanks,
                      "depAirportCode": item.sAirportCode,
                      "depDate": item.beginDate,
                      "depTime": item.beginTime,
                      "flightNo": item.flightNo,
                      "routeId": item.routeId,
                      "stopover":item.stopItemList,
                      "planeType":item.planeType,
                      "sTerminal":item.sTerminal,
                      "eTerminal":item.eTerminal,
                      "codeShare":item.codeShare
                      // "supplierRouteId": item.segmentType
                    }
                  return obj
            })
            let _a = {
              "routeList":routeList,
              "segmentId":this.ticketFlight[flightIndex].segmentId,
              "segmentType":this.ticketFlight[flightIndex].segmentType
            }
            return _a
       })
        let data = {
          "orderNo": this.orderNo,
          "passengerList": passengerList,
          "remark": this.applyStatus.text,
          "segmentList":ticketFlight
          }
        // console.log(JSON.stringify(data))
        pkfareChangeRequest(data).then(res=>{
          this.$message({type:"success",message:"改签成功！"})
          this.$router.push({name:'air-ticket-admin-change-order',params:{refresh:1}})
        })
      }
    },
    amend(text){
        this.$router.push({
            query:{ordersNo:this.orderNo,type:text,supplierType:this.$route.query.supplierType}
        })
        this.type = text
        this.getDetail(text)
    },
  },
  created() {
      this.orderNo = this.$route.query.ordersNo
      this.supplierType = this.$route.query.supplierType
      this.type = this.$route.query.type
      this.getDetail(this.type)
      this.loadAllInternationalCity()
  }
};
</script>
<style lang="less" scoped>
.airDetails {
  width: 100%;
}

.df {
  display: flex;
}
.Details_data {
  background: #fffcfa;
  border: solid 1px #ffb27f;
  h5 {
    padding-left: 30px;
    font-size: 14px;
    color: #666666;
    line-height: 32px;
    height: 32px;
    background: #fff5ef;
  }
  .Details_text {
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 30px;
    span {
      display: inline-block;
      width: 33%;
      font-size: 14px;
      color: #666;
      line-height: 25px;
      height: 25px;
    }
  }
}
.relation-box{
  padding: 20px 25px;
  font-size: 14px;
  color: #666;
  .title{
    padding: 10px 0;
  }
  div{
    display: flex;
    align-items: center;
    span{
      padding-right: 20px;
    }
    .el-input{
      width: 200px;
      input{
        text-align: left
      }
    }
  }
}
.passenger,
.changing_box {
  border: 1px solid #e9e9e9;
  margin-bottom: 20px;
  margin-top: 20px;
  h2 {
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    background: #237dc8;
    color: #4b4b4b;
    padding-left: 8px;
    p {
      background-color: #ecf6ff;
      vertical-align: middle;
      padding-left: 20px;
    }
  }
  .passenger_top {
    padding: 0 15px;
    text-align: center;
    background: #f1f3f5;
    color: #666;
    line-height: 25px;
    font-size: 14px;
  }
  .passenger_body {
    padding: 0 15px;
  }
  .passengerD {
    // height: 40px;
    padding: 10px 0;
    background: #fff;
    font-size: 14px;
    // line-height: 40px;
    text-align: center;
    border-top: 1px solid #ececec;
    &:nth-child(1) {
      border-top: none;
    }
    > div {
      p {
        word-break: break-all;
        text-align: center;
      }
    }
  }
  .airList {
    border-top: 1px dashed #e9e9e9;
  }
  .airList {
    height: 60px;
    font-size: 12px;
    text-align: center;
    color: #999;
    > div {
      height: 30px;
      line-height: 30px;
    }
    .airList_Top {
      background: #ecf6ff;
      height: 20px;
      line-height: 20px;
    }
  }
  .changing {
    color: #237dc8;
    cursor: pointer;
  }
}
.price-list {
  border-bottom: 1px solid #ececec;
  text-align: center;
  padding: 10px;
  span {
    color: #ff6334;
  }
}
.text-warning {
  color: red;
  font-size: 14px;
  padding: 10px 40px;
}
.fare-list{
  width: 97%;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 14px;
  border: 1px solid #e9e9e9;
  color: #666;

  .people-info{
     padding: 15px;
     background: #f1f3f5;
     span{
       padding: 0 15px;
     }
  }
  .air-list{
    padding: 10px 0;
    h4:nth-child(1){
      padding: 0 15px;
    }
    .el-date-editor{
      width: auto;
    }
  }
  /deep/.el-table{
    td{
      font-size: 12px;
      .el-input__inner{
        padding: 0;
      }
      /deep/.el-input__icon{
          line-height: 30px;
        }
    }
  }
}
/deep/.el-input{
      // height: 30px;
     input{
        height: 30px;
        border-radius: 0;
     }
    }
.el-button{
  border-radius: 0;
}
.table-time{
  .el-input{
    margin-bottom: 1px;
    width: 100px;
    /deep/.el-input__icon{
      line-height: 30px;
    }
  }
}
.flight-route-style{
  font-size: 14px;
  color: white;
  padding: 5px 20px;
  background:#ffb27f;
  transform: translate(-1px)
}
.flight-route-style2{
  background: #5eadff;
}
.ticket-paging{
  padding:10px 0;
}
.arrows-stop-info{
  left: -368% !important;
}
.passenger_body{
  border-bottom: 1px dashed #dfdfdf;
  margin-bottom: 2px;
}
</style>
<style lang='less' scoped>
@import "../css/international";
</style>
